module.exports = __webpack_public_path__ + "static/dojazd-photo03-0705bddbef45ad5c608cc0469a9a2c41.jpg";